<template>
	<PlanComparisonPaywall
		v-if="showPaywallModal"
		headline="Your first application has been submitted!"
		subcopy="Ready to apply faster, smarter, and with better results?"
		:reopen="() => (showPaywallModal = true)"
		@close="retentionStore.markPaywallSeen()"
		@stay-free="retentionStore.showCoachingAfterStayFree()"
		@upgrade="retentionStore.markPaywallSeen()"
	/>
</template>

<script setup>
import { storeToRefs } from 'pinia';

import PlanComparisonPaywall from '../plan-comparison-paywall.vue';
import { useOnboardingRetentionStore } from '../../store/onboarding-retention.store';

/**
 * EN-639: the paywall shown once, immediately after a net-new free user submits their
 * first application. Closing it (X / backdrop / Esc) or upgrading just marks it seen;
 * declining via "Stay On Free" also surfaces the coaching nudge.
 */
const retentionStore = useOnboardingRetentionStore();
const { showPaywallModal } = storeToRefs(retentionStore);
</script>
